module.exports = __webpack_public_path__ + "img/c02_buildingscalemailandhidearmor_Normal_ua.451132cd.webp";